// Color picker component
import React from 'react';
import { CATEGORY_COLORS } from '../utils/categoryIcons';

const ColorPicker = ({ value, onChange, label = 'Color' }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="flex flex-wrap gap-2">
        {CATEGORY_COLORS.map((color) => (
          <button
            key={color.value}
            type="button"
            onClick={() => onChange(color.value)}
            className={`w-10 h-10 rounded-full border-2 transition-all hover:scale-110 ${
              value === color.value
                ? 'border-gray-900 ring-2 ring-offset-2 ring-gray-900'
                : 'border-gray-300'
            }`}
            style={{ backgroundColor: color.value }}
            title={color.label}
          />
        ))}
      </div>
    </div>
  );
};

export default ColorPicker;
